module.exports = __webpack_public_path__ + "static/img/transistor-1.9a1e7ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/transistor-1.svg
// module id = hGbI
// module chunks = 0